export const RESPONSE_FORM = 'RESPONSE_FORM';
export const DAILY_DATE_FORMAT = 'DD';
